import { createContext } from "react";

const loginContext = createContext({
  user: {},
  login: () => {},
  logout: () => {},
});

export { loginContext };
